import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/allocation/")({
  loader: ({ location }) => {
    if (location.pathname === "/allocation") {
      throw redirect({ to: "/allocation/replenishment" })
    }
    return null
  },
})
